/**
 * HotelEngine
 * google_places_search.js
 */

(function GooglePlaces($, HE)
{
	"use strict";

	// selectors used for instantiating this must be unique.
	// unfortunately, there's no way to reliably get the selector used to create
	// a jQuery object, so i'm only tracking string-based selectors.
	var selectors = [];

	var places = function GooglePlaces(el)
	{
		var $el,
		    $input_field,
		    postdata = {},
		    search_type,
		    include_types;

		try
		{
			if (el instanceof jQuery) {
				$el = el;
			}
			else {
				if (selectors.indexOf(el) === -1) {
					selectors.push(el);
				}
				else {
					console.warn('[HE.GooglePlacesSearch] potential duplicate selector detected:', el);
				}

				$el = $(el);
			}

			$input_field  = $el.find('input[type="text"]');
			search_type   = $el.data('search-type');
			include_types = $el.data('include');

			if (!$input_field.length) {
				throw new Error('Cannot find input field.');
			}

			postdata = {
				type: search_type
			};

			if (include_types) {
				postdata.include = include_types;
			}
		}
		catch (err) {
			console.error('[HE.GooglePlacesSearch]', err);
			return;
		}

		HE.Typeahead(
			$input_field,
			function search(term, display, $self)
			{
				postdata.term = term;

				HE.Ajax.post('/Searches/destinations', postdata)
				.then(function searchResults(places)
				{
					$self.removeClass('ajax-spinner');
					display(places.results || [{name: places.message}]);
				})
				.catch(function searchError()
				{
					$self.removeClass('ajax-spinner');
					display([{name: "Error searching for places."}]);
				});
			},
			function select(item, $self)
			{
				if (!item.place_id && !include_types) {
					return;
				}

				populateInputs($self, item);
				$self.trigger('gp.selected', [item]);
			},
			function template(item) {
				if (item.vicinity) {
					item.name = item.name+', '+item.vicinity;
				}
				return JSON.stringify(item);
			}
		);

		$input_field.on('click', function focused() {
			clearInputs(this);
		});

		function populateInputs($input, item)
		{
			var $inputs = $input.parents('.destination-search').find('input').not($input_field),
			    _$input;

			$.each($inputs, function _populateInput(i, input) {
				_$input = $(input);
				_$input.val(item[_$input.attr('class')]);
			});
		}

		function clearInputs(el)
		{
			var $inputs = $(el).parents('.destination-search').find('input');
			$inputs.val('');
		}
	};

	HE.GooglePlaces = places;
}(jQuery, window.HE || {}));
